import React, { Component } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Divider,
    Grid,
    MenuItem,
    Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField,
    Typography
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { ProductOption } from "../../../classes/types/product/product";
import { CartItem, CartItemAddon } from "../../../classes/types/cart/cart";
import defaultImage from "../../../assets/defaultImage.jpg";
import { euroPrint } from "../../../classes/types/currencysettings";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Paper from "@mui/material/Paper";
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

interface props {
    cartItem: CartItem,
    onRemoveProductCallback: (cartItemSelected: CartItem) => any,
    onQuantityChange: (cartItemSelected: CartItem) => any,
    items: Array<CartItem>,
}

interface state {
    showDeleteProductDialog: boolean,
    quantity: number,
    productOptions: Array<ProductOption>,
    selectedCartItem: CartItem,
    totalPrice: number
    quantitySelector: Array<number>;
    showEditConfiguration: boolean;
    maxQuantity: number;
}

export default class ProductCartItem extends Component<props, state> {
    constructor(props: props) {
        super(props);

        this.state = {
            showDeleteProductDialog: false,
            quantity: 1,
            productOptions: Array<ProductOption>(),
            selectedCartItem: this.props.cartItem,
            totalPrice: 0,
            quantitySelector: new Array<number>(),
            showEditConfiguration: false,
            maxQuantity: 0,
        }
    }
    componentDidMount() {
        this.refreshData();
    }

    componentDidUpdate(prevProps: Readonly<props>, prevState: Readonly<state>, snapshot?: any) {
        if (this.props.cartItem !== prevProps.cartItem) {
            this.refreshData();
        }
    }

    refreshData = () => {
        let newQuantitySelectorArray = new Array<number>();
        if (this.props.cartItem.product.configurable) {
            for (let i = 0; i < 5; i++) {
                newQuantitySelectorArray.push(i + 1);
            }
        } else if (this.props.cartItem.product.stock1 > 0) {
            let quantity = this.props.cartItem.product.stock1;
            for (let i = 0; i < quantity; i++) {
                newQuantitySelectorArray.push(i + 1);
            }
        } else {
            newQuantitySelectorArray.push(1);
        }
        this.setState({
            quantitySelector: newQuantitySelectorArray,
        })
    }

    onCalculateProductPrice = () => {
        let totalPrice = 0;
        if (this.state.selectedCartItem.product.price !== undefined) {
            totalPrice = this.state.selectedCartItem.product.price;
        }
        this.state.selectedCartItem.addons.forEach((addon) => {
            if (addon.selectedOptionPrice > 0) {
                totalPrice += addon.selectedOptionPrice * addon.selectedQuantity;
            } else if (addon.selectedOption !== undefined) {
                totalPrice += addon.selectedOption.price * addon.selectedQuantity;
            }
        })

        totalPrice = totalPrice * this.state.selectedCartItem.quantity;

        return totalPrice;
    }

    render() {
        console.log(this.props.cartItem);
        return (
            <div className="product-card-item" style={{ marginBottom: '2%', marginLeft: "40px" }}>
                <Grid style={{ textAlign: "left", marginTop: "10px" }} container>
                    <Grid style={{ overflow: 'hidden', maxWidth: '100%', height: '140px', cursor: 'pointer' }} direction={"column"} xs={2} justifyContent={"center"} alignContent={"center"} item container>
                        <div style={{ padding: "5%", overflow: 'hidden', cursor: 'pointer' }}>
                            <Link to={`/shop/home/prodotto/` + this.props.cartItem.productId}>{<img style={{ cursor: 'pointer', height: '100%', width: '100%', objectFit: 'contain' }} src={this.props.cartItem.imageUrl !== undefined && this.props.cartItem.imageUrl !== "" ? this.props.cartItem.imageUrl : defaultImage} alt={this.state.selectedCartItem.product.name + '-image'} />}</Link>
                        </div>
                    </Grid>
                    <Grid md={7} item>
                        <Link to={`/shop/home/prodotto/` + this.props.cartItem.productId}><Typography style={{ cursor: 'pointer' }} variant="h6">{this.props.cartItem.product.name}</Typography></Link>
                        <div>Codice prodotto: {this.props.cartItem.product.sku}</div>
                        <div hidden={this.props.cartItem.product.configurable} style={{ color: this.props.cartItem.product.stock1 > 0 ? "green" : "red", fontSize: "18px" }}>Rimanenti in magazzino: {this.props.cartItem.product.stock1}</div>
                        {this.props.cartItem.product.stock1 === 0 && this.props.cartItem.product.arrivingQuantity === 0 ?
                            <Typography
                                style={{
                                    // paddingTop: "5%",
                                    // paddingBottom: "5%",
                                    // fontWeight: 400,
                                    color: "red",
                                    textAlign: "left",
                                }}
                                variant="subtitle2"
                            >
                                Da ordinare.
                            </Typography> :
                            this.props.cartItem.product.arrivingQuantity > 0 && (this.props.cartItem.quantity > this.props.cartItem.product.stock1) && (this.props.cartItem.quantity <= this.props.cartItem.product.arrivingQuantity + this.props.cartItem.product.stock1) ?
                                <Typography
                                    style={{
                                        paddingTop: "5%",
                                        // paddingBottom: "5%",
                                        // fontWeight: 400,
                                        color: "orange",
                                        textAlign: "left",
                                    }}
                                    variant="subtitle2"
                                >
                                    Per {this.props.cartItem.quantity - this.props.cartItem.product.stock1} pezzi il tempo di arrivo sarà
                                    {(this.props.cartItem.product.arrivingQuantityDate !== ""
                                        ? dayjs(
                                            this.props.cartItem.product.arrivingQuantityDate,
                                            "YYYY-MM-DD"
                                        ).isSame(dayjs()) ||
                                            dayjs(
                                                this.props.cartItem.product.arrivingQuantityDate,
                                                "YYYY-MM-DD"
                                            ).isBefore(dayjs())
                                            ? " durante la giornata odierna"
                                            : " al " +
                                            dayjs(
                                                this.props.cartItem.product.arrivingQuantityDate,
                                                "YYYY-MM-DD"
                                            ).format("DD/MM/YYYY")
                                        : "")}.
                                </Typography> :
                                this.props.cartItem.product.arrivingQuantity > 0 && (this.props.cartItem.quantity > this.props.cartItem.product.arrivingQuantity + this.props.cartItem.product.stock1) ?
                                    <Typography
                                        style={{
                                            // paddingTop: "5%",
                                            // paddingBottom: "5%",
                                            // fontWeight: 400,
                                            color: "orange",
                                            textAlign: "left",
                                        }}
                                        variant="subtitle2"
                                    >
                                        {this.props.cartItem.quantity - this.props.cartItem.product.arrivingQuantity - this.props.cartItem.product.stock1} pezzi sono da ordinare
                                        {/* {(this.props.cartItem.product.arrivingQuantityDate !== ""
                                            ? dayjs(
                                                this.props.cartItem.product.arrivingQuantityDate,
                                                "YYYY-MM-DD"
                                            ).isSame(dayjs()) ||
                                                dayjs(
                                                    this.props.cartItem.product.arrivingQuantityDate,
                                                    "YYYY-MM-DD"
                                                ).isBefore(dayjs())
                                                ? " dopo la giornata odierna"
                                                : " dopo il " +
                                                dayjs(
                                                    this.props.cartItem.product.arrivingQuantityDate,
                                                    "YYYY-MM-DD"
                                                ).format("DD/MM/YYYY")
                                            : "")}. */}
                                    </Typography> :
                                    this.props.cartItem.product.stock1 > 0 && this.props.cartItem.quantity > this.props.cartItem.product.stock1 &&
                                    <Typography
                                        style={{
                                            // paddingTop: "5%",
                                            // paddingBottom: "5%",
                                            // fontWeight: 400,
                                            color: "orange",
                                            textAlign: "left",
                                        }}
                                        variant="subtitle2"
                                    >
                                        {this.props.cartItem.quantity - this.props.cartItem.product.stock1} pezzi sono da ordinare
                                    </Typography>}
                        <span style={{ fontSize: "18px", marginRight: "15px" }}>Quantità  </span>
                        <TextField
                            variant="standard"
                            type="number"
                            label="Quantità"
                            value={this.state.selectedCartItem.quantity}
                            disabled={
                                /*this.state.selectedCartItem.quantity >
                                this.state.selectedCartItem.product.stock1 &&*/
                                !this.state.selectedCartItem.product.configurable
                            }
                            onChange={this.onQuantityChange}
                            inputProps={{ min: 1 }}
                        />
                    </Grid>
                    <Grid md={3} justifyContent={"flex-end"} direction={"column"} container item>
                        <div>
                            <Typography style={{ float: "right", marginTop: "2px", whiteSpace: "nowrap" }} variant="h5"><b>{euroPrint(this.onCalculateProductPrice())}</b></Typography>
                        </div>
                        <Typography align='right'>{this.props.cartItem.product.taxSIAE > 0 ? `+ SIAE ${euroPrint(this.props.cartItem.product.taxSIAE * this.props.cartItem.quantity)}` : ""}</Typography>
                        <div style={{ marginTop: "auto", display: "flex", flexDirection: "column" }} >
                            <div><Button onClick={() => this.setShowDeleteProductDialog(true)} style={{ float: "right" }} variant="contained" startIcon={<Delete />} color="primary">Rimuovi</Button></div>
                            {this.state.selectedCartItem.addons.length > 0 ? <div><Button onClick={() => this.setShowEditConfigurationProductDialog(true)} style={{ float: "right", marginTop: '2%' }} variant="contained" startIcon={<VisibilityIcon />} color="primary">Configurazione</Button></div> : null}
                        </div>
                    </Grid>
                </Grid>
                <Dialog
                    open={this.state.showDeleteProductDialog}
                    onClose={() => this.setShowDeleteProductDialog(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Rimuovere oggetto dal carrello?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Sei sicuro di voler rimuovere questo oggetto dal tuo carrello? Perderai la configurazione salvata!
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setShowDeleteProductDialog(false)} >
                            Annulla
                        </Button>
                        <Button onClick={this.handleDeleteProduct} color="primary" autoFocus>
                            Rimuovi dal carrello
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.showEditConfiguration}
                    onClose={() => this.setShowEditConfigurationProductDialog(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Opzioni Selezionate"}</DialogTitle>
                    <DialogContent>
                        <div className="configurator" hidden={(this.state.selectedCartItem.addons.length <= 0)}>
                            <Divider variant="middle" />
                            <TableContainer style={{ width: '100%' }} component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                Nome
                                            </TableCell>
                                            <TableCell>
                                                Opzione
                                            </TableCell>
                                            <TableCell>
                                                Quantità
                                            </TableCell>
                                            <TableCell>
                                                Prezzo
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.selectedCartItem.addons.map((addon: CartItemAddon, confIndex: number) => {
                                            return (
                                                <TableRow key={confIndex} >
                                                    <TableCell>
                                                        {addon.addonName}
                                                    </TableCell>
                                                    <TableCell>
                                                        {addon.selectedOptionName}
                                                    </TableCell>
                                                    <TableCell>
                                                        {addon.selectedQuantity}
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                        {euroPrint((addon.selectedOptionPrice !== undefined ? (addon.selectedOptionPrice * addon.selectedQuantity) : addon.selectedOption != null ? addon.selectedOption.price : 0))}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button color={'primary'} onClick={() => this.setShowEditConfigurationProductDialog(false)} >
                            Chiudi
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    onQuantityChange = (e: any) => {
        let selectedCartItemCopy = new CartItem();
        selectedCartItemCopy = Object.assign({}, this.props.cartItem);
        selectedCartItemCopy.quantity = e.target.value;
        this.setState({
            selectedCartItem: selectedCartItemCopy
        }, () => this.props.onQuantityChange(selectedCartItemCopy));
    }

    setShowDeleteProductDialog = (show: boolean) => {
        this.setState({
            showDeleteProductDialog: show,
        })
    }

    setShowEditConfigurationProductDialog = (show: boolean) => {
        this.setState({
            showEditConfiguration: show,
        })
    }

    handleDeleteProduct = () => {
        this.setState({
            showDeleteProductDialog: false,
        }, () => this.props.onRemoveProductCallback(this.props.cartItem));
    }

}
